module.exports = __webpack_public_path__ + "media/images/edit-a9cf3bea.png";